import {
    Grid,
    Typography
} from '@mui/material';

const TermsAndConditionsForm = () => {
    return (
        <Grid container>
            <Grid item md={12} sm={12} xs={12}>
                <Typography component={'div'} className='set-parent-settings d-flex-ja'>
                    <Typography component={'div'} className='set-child'>
                        <Typography className='p-title sett-box d-flex-a px-24'>Terms & Conditions</Typography>
                        <Typography component={'div'} className='company-text'>
                            People Optimizaton Index
                        </Typography>
                        <Typography component={'div'} className='px-24'>
                            1. Acceptance of Terms
By accessing or using the People Optimization Index (“POI,” “we,” “our,” or “us”) website and application, you agree to be bound by these Terms and Conditions (“Terms”).<br/>
If you do not agree to these Terms, you may not use the POI platform.
<br/>
2. Description of Services<br/>
POI provides:
<br/>
Employee survey and engagement tools<br/>
Analytics and reporting dashboards<br/>
Benchmarking and people optimization insights<br/>
Communication tools, including email and SMS notifications (if enabled)<br/>
POI may modify, enhance, or discontinue services at any time.<br/>
<br/>
3. User Accounts and Responsibilities<br/>
3.1 Account Access<br/>
You agree to:<br/>
<br/>
Provide accurate and complete information<br/>
Maintain the confidentiality of your login credentials<br/>
Notify us immediately of unauthorized access<br/>
<br/>
3.2 Acceptable Use<br/>
You agree not to:<br/>
<br/>
Use the platform for unlawful or harmful purposes<br/>
Interfere with system security or operations<br/>
Attempt unauthorized access to data or systems<br/>
Upload malicious code or harmful content<br/>
<br/>
4. Data Ownership and Use<br/>
4.1 Customer Data<br/>
Organizations using POI retain ownership of their data<br/>
POI acts as a service provider processing data on behalf of customers<br/>
<br/>
4.2 User Data<br/>
Survey responses and user-generated content may be processed and analyzed<br/>
Data may be aggregated and anonymized for analytics and improvement purposes<br/>
<br/>
5. Employer-Provided Access<br/>
If you access POI through your employer:<br/>
<br/>
Your organization controls data configuration and access permissions<br/>
Your activity and responses may be visible to administrators based on system settings<br/>
Your organization’s policies may also apply<br/>
<br/>
6. SMS and Communications<br/>
If enabled:<br/>
You may receive text messages related to surveys, reminders, or system alerts<br/>
You may opt out at any time by replying “STOP”<br/>
Message and data rates may apply<br/>
<br/>
7. Intellectual Property<br/>
All POI content, including:<br/>
Software<br/>
Interfaces<br/>
Documentation<br/>
Branding and trademarks<br/>
<br/>
are owned by POI or its licensors and are protected by intellectual property laws.<br/>
You may not:<br/>
<br/>
Copy, modify, or distribute the platform<br/>
Reverse engineer or attempt to extract source code<br/>
<br/>
8. Third-Party Services<br/>
POI may integrate with third-party systems such as:<br/>
<br/>
HRIS and payroll systems<br/>
Cloud hosting providers<br/>
Messaging and analytics tools<br/>
<br/>
We are not responsible for the practices or performance of third-party services.<br/>
<br/>
9. Privacy<br/>
Your use of POI is also governed by our Privacy Policy, which explains how your data is collected, used, and protected.<br/>
<br/>
10. Data Security<br/>
We implement reasonable security measures, including:<br/>
<br/>
Role-based access controls<br/>
Encryption in transit<br/>
Secure cloud hosting environments<br/>
<br/>
However, no system is completely secure, and you use the platform at your own risk.<br/>
<br/>
11. Disclaimer of Warranties<br/>
POI is provided “as is” and “as available.”<br/>
We do not guarantee:<br/>
<br/>
Continuous availability or uptime<br/>
Accuracy or completeness of analytics insights<br/>
Error-free operation<br/>
<br/>
To the fullest extent permitted by law, we disclaim all warranties, express or implied.<br/>
<br/>
12. Limitation of Liability<br/>
To the maximum extent permitted by law:<br/>
POI shall not be liable for:<br/>
<br/>
Indirect, incidental, or consequential damages<br/>
Loss of data, profits, or business opportunities<br/>
Decisions made based on analytics or reports<br/>
<br/>
Our total liability shall not exceed the amount paid for the service in the preceding 12 months.<br/>
<br/>
13. Indemnification<br/>
You agree to indemnify and hold harmless POI from any claims, damages, or losses arising from:<br/>
<br/>
Your use of the platform<br/>
Violation of these Terms<br/>
Misuse of data or unauthorized activity<br/>
<br/>
14. Termination<br/>
We may suspend or terminate access if:<br/>
<br/>
You violate these Terms<br/>
Your account is inactive or compromised<br/>
Required by law or business necessity<br/>
<br/>
You may stop using the platform at any time.<br/>
<br/>
15. Changes to Terms<br/>
We may update these Terms periodically.<br/>
Changes will be posted with an updated effective date. Continued use of POI constitutes acceptance of updated Terms.<br/>
<br/>
16. Governing Law<br/>
These Terms are governed by the laws of: Texas<br/>
Any disputes shall be resolved in the appropriate courts of that jurisdiction.<br/>
<br/>
17. Contact Information<br/>
For questions regarding these Terms:<br/>
People Optimization Index
People Optimization Index<br/>
Email: infosecurity@theencompassgroup.com<br/>
Address: 405 State Highway 121 Bypass<br/>
Suite D120<br/>
Lewisville, TX 75067.
                        </Typography>
                        <Typography component={'div'} className='px-24'>                            
                        </Typography>
                        <Typography component={'div'} className='box-bottom'>
                            &copy; The Encompasss Group (2026)
                        </Typography>
                    </Typography>
                </Typography>
            </Grid>
        </Grid>
    )
}

export default TermsAndConditionsForm;